import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS } from '../Constants/Constants';

@Injectable()
export class MultilingualDateAdapter extends NativeDateAdapter {

  constructor(private readonly translateService: TranslateService) {
    super('en-US');
  }

  override format(date: Date, displayFormat: object): string {
    const currentLang = this.translateService.currentLang || this.translateService.defaultLang || CONSTANTS.LANGUAGE_EN_US;

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const dd = this.padNumber(day);
    const mm = this.padNumber(month);

    if (currentLang === CONSTANTS.LANGUAGE_FR_CA || currentLang === CONSTANTS.LANGUAGE_EN_CA) {
      return `${year}-${mm}-${dd}`;
    } else {
      return `${mm}/${dd}/${year}`;
    }
  }

  override parse(value: string): Date | null {
    if (!value || value.trim() === '') {
      return null;
    }

    const currentLang = this.translateService.currentLang || this.translateService.defaultLang || CONSTANTS.LANGUAGE_EN_US;

    if (currentLang === CONSTANTS.LANGUAGE_FR_CA || currentLang === CONSTANTS.LANGUAGE_EN_CA) {
      const parts = value.split('-');
      if (parts.length === 3) {
        const year = Number.parseInt(parts[0], 10);
        const month = Number.parseInt(parts[1], 10) - 1;
        const day = Number.parseInt(parts[2], 10);
        if (!Number.isNaN(year) && !Number.isNaN(month) && !Number.isNaN(day)) {
          return new Date(year, month, day);
        }
      }
    } else {
      const parts = value.split('/');
      if (parts.length === 3) {
        const month = Number.parseInt(parts[0], 10) - 1;
        const day = Number.parseInt(parts[1], 10);
        const year = Number.parseInt(parts[2], 10);
        if (!Number.isNaN(year) && !Number.isNaN(month) && !Number.isNaN(day)) {
          return new Date(year, month, day);
        }
      }
    }

    return super.parse(value);
  }

  private padNumber(n: number): string {
    return n < 10 ? `0${n}` : `${n}`;
  }
}
